import { createTheme } from "@mui/material/styles";
import { COMMON_COLORS, DARK_COLORS } from "./colors";

const darkTheme = createTheme({
    palette: {
        mode: "dark",
        primary: {
            main: COMMON_COLORS.primary
        },
        secondary: {
            main: COMMON_COLORS.secondary
        },
        background: {
            default: DARK_COLORS.backgroundDefault,
            paper: DARK_COLORS.backgroundPaper
        },
        text: {
            primary: DARK_COLORS.textPrimary,
            secondary: DARK_COLORS.textSecondary
        },
        chatEmptyStateTitle: DARK_COLORS.chatEmptyStateTitle,
        errorArrow: COMMON_COLORS.errorArrow,
        userMessageBG: DARK_COLORS.userMessageBG,
        white: COMMON_COLORS.white,
        black: COMMON_COLORS.black,
        containerBG: DARK_COLORS.containerBG,
        exampleContainer: DARK_COLORS.exampleContainer,

        pieChartFaded: DARK_COLORS.pieChartFaded,
        kpiCardTitle: DARK_COLORS.kpiCardTitle,
        kpiCardValue: DARK_COLORS.kpiCardValue,

        successColor: COMMON_COLORS.successColor,
        errorColor: COMMON_COLORS.errorColor,
        allLogColor: COMMON_COLORS.allLogColor,
        normalLogColor: COMMON_COLORS.normalLogColor,
        systemError: COMMON_COLORS.systemError,
        filteredChat: COMMON_COLORS.filteredChat,

        dateTime: DARK_COLORS.dateTime,
        chatHistoryUserMessageBubble: DARK_COLORS.chatHistoryUserMessageBubble,
        chatHistoryAiMessageBubble: DARK_COLORS.chatHistoryAiMessageBubble,
        citationsLabel: DARK_COLORS.citationsLabel,

        feedbackCardBG: DARK_COLORS.feedbackCardBG,
        feedbackCardHoverBG: DARK_COLORS.feedbackCardHoverBG,

        red: COMMON_COLORS.lightRed,

        gridRowHover: DARK_COLORS.gridRowHover,
        gridRowSelected: DARK_COLORS.gridRowSelected,
        fileGridHeaderBG: DARK_COLORS.fileGridHeaderBG,
        fileGridHeaderBorder: DARK_COLORS.fileGridHeaderBorder,
        fileGridBackground: DARK_COLORS.fileGridBackground,
        fileRowBackground: DARK_COLORS.fileRowBackground,

        alexxisTextGradientAccent: COMMON_COLORS.alexxisTextGradientAccent,
        loadingDotInitial: DARK_COLORS.loadingDotInitial,
        loadingDotMiddle: DARK_COLORS.loadingDotMiddle,
        loadingDotFinal: DARK_COLORS.loadingDotFinal,

        citationBackground: DARK_COLORS.citationBackground,
        citationBackgroundHover: DARK_COLORS.citationBackgroundHover,

        actionButtonBackground: DARK_COLORS.actionButtonBackground,
        actionButtonBackgroundHover: DARK_COLORS.actionButtonBackgroundHover,

        shortCutKeyBackground: DARK_COLORS.shortCutKeyBackground,
        scrollbarThumb: DARK_COLORS.scrollbarThumb,
        scrollbarTrack: DARK_COLORS.scrollbarTrack,

        drawerMenuBackground: DARK_COLORS.drawerMenuBackground,
        cardBackground: DARK_COLORS.cardBackground,
        datagridOverlayBackground: DARK_COLORS.datagridOverlayBackground,
        primaryButtonIcon: DARK_COLORS.primaryButtonIcon,
        primaryIcon: DARK_COLORS.primaryIcon,
        secondaryIcon: DARK_COLORS.secondaryIcon,

        borderColor: DARK_COLORS.borderColor,
        borderColorHover: DARK_COLORS.borderColorHover,

        disclaimerText: DARK_COLORS.disclaimerText,

        animatedTabBackground: DARK_COLORS.animatedTabBackground,
        animatedTabActiveBackground: DARK_COLORS.animatedTabActiveBackground,
        animatedTabText: DARK_COLORS.animatedTabText,
        animatedTabActiveText: DARK_COLORS.animatedTabActiveText,
        animatedTabHoverBackground: DARK_COLORS.animatedTabHoverBackground,
        animatedTabHoverText: DARK_COLORS.animatedTabHoverText,

        //File colors
        word: COMMON_COLORS.word,
        excel: COMMON_COLORS.excel,
        powerpoint: COMMON_COLORS.powerpoint,
        pdf: COMMON_COLORS.pdf,
        txt: COMMON_COLORS.txt,
        html: COMMON_COLORS.html,
        css: COMMON_COLORS.css,
        js: COMMON_COLORS.js,
        json: COMMON_COLORS.json,
        image: COMMON_COLORS.image,
        audio: COMMON_COLORS.audio,
        video: COMMON_COLORS.video,
        defaultFile: COMMON_COLORS.defaultFile,
        folder: COMMON_COLORS.folder,

        dropzoneBackground: DARK_COLORS.dropzoneBackground,
        dropzoneBorder: DARK_COLORS.dropzoneBorder,
        dropzoneBorderPulse: DARK_COLORS.dropzoneBorderPulse
    },
    typography: {
        fontFamily: '"TT Norms", sans-serif',
        fontSize: 16,
        h1: { fontSize: "3.5rem" },
        h2: { fontSize: "1.5rem" },
        h3: { fontSize: "1.25rem" }
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: "#FFFFFF",
                    "&:hover": {
                        color: "#28D7CA"
                    }
                }
            }
        },

        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: "#000",
                    borderRadius: "8px",
                    padding: "8px"
                },
                arrow: {
                    color: "#000"
                }
            }
        }
    }
});

export default darkTheme;
